import { hubApplication } from './hub';
import { lensApplication } from './lens';
import { pixelRadApplication } from './pixel-rad';
import { nextIntelligenceApplication } from './next-intelligence';
import { nextPlatformApplication } from './next-platform';
import { trialsApplication } from './trials-app';
import { davidApplication } from './david';

export const APPLICATIONS = [
  hubApplication,
  lensApplication,
  pixelRadApplication,
  nextIntelligenceApplication,
  nextPlatformApplication,
  trialsApplication,
  davidApplication,
];
